import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-contents" }
const _hoisted_2 = { class: "reviewCommentProperties" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "d-flex flex-column gap-3 reviewCommentCommentContainer" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-redlining" }, null, -1)
const _hoisted_9 = { class: "reviewCommentOptions" }
const _hoisted_10 = ["disabled", "name", "id", "value", "onClick"]
const _hoisted_11 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_ReviewCommentTextArea = _resolveComponent("ReviewCommentTextArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("dl", _hoisted_3, [
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t('general.reviewer')), 1),
        _createElementVNode("dd", null, [
          _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.result }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.result.commentedOrganisationName) + " (" + _toDisplayString(_ctx.result.commentedPersonGivenName) + " " + _toDisplayString(_ctx.result.commentedPersonSurName) + ") ", 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t('general.realmShort')), 1),
        _createElementVNode("dd", null, [
          _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.result }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.result.commentedRealmCode) + " " + _toDisplayString(_ctx.$s(_ctx.result.commentedRealmName)), 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t('general.date')), 1),
        _createElementVNode("dd", null, [
          _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.result }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$d(new Date(_ctx.result.commentedResultResultDate * 1000))), 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t('general.review')), 1),
        _createElementVNode("dd", null, [
          _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.result }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.sanitize(_ctx.result.commentedResultComment)
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t('general.result')), 1),
        _createElementVNode("dd", _hoisted_5, [
          _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.result }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$s(_ctx.result.commentedOptionName)), 1)
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_ReviewCommentTextArea, {
        disabled: this.disabled,
        modelValue: _ctx.value.comment,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.comment) = $event))
      }, null, 8, ["disabled", "modelValue"]),
      _createElementVNode("a", {
        href: _ctx.redliningLink,
        class: "text-decoration-none text-body text-end"
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('general.redlining')) + " ", 1),
        _hoisted_8
      ], 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (commentOption) => {
        return (_openBlock(), _createElementBlock("div", {
          key: commentOption.reviewCycleCommentOptionId,
          class: "form-check"
        }, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            disabled: this.disabled,
            type: "radio",
            name: _ctx.$id('option'),
            id: _ctx.$id('option' + commentOption.reviewCycleCommentOptionId),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.reviewCycleCommentOptionId) = $event)),
            value: commentOption.reviewCycleCommentOptionId,
            onClick: ($event: any) => (this.optionChosen(commentOption))
          }, null, 8, _hoisted_10), [
            [_vModelRadio, _ctx.value.reviewCycleCommentOptionId]
          ]),
          _createElementVNode("label", {
            class: "form-check-label",
            for: _ctx.$id('option' + commentOption.reviewCycleCommentOptionId)
          }, [
            _createVNode(_component_LoadedOrPlaceholder, { value: commentOption }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$s(commentOption.reviewCycleCommentOptionName)), 1)
              ]),
              _: 2
            }, 1032, ["value"])
          ], 8, _hoisted_11)
        ]))
      }), 128))
    ])
  ]))
}